import { parseRegion } from 'models/Region';
import { getConfiguration } from 'components/contexts/ClientConfiguration';

const Api = {
	getBaseUrl: () => {
		const config = getConfiguration();
		return config.baseUrl;
	},
	getClientId: () => {
		const config = getConfiguration();
		return config.clientId;
	},
	getRegion: () => {
		const config = getConfiguration();
		return parseRegion(config.region);
	}
};

export default Api;